import {
  Description as DocumentIcon,
  Email as EmailIcon,
  AttachMoney as MoneyIcon,
  CheckBox as TaskIcon,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

const Dashboard = () => {
  const statsCards = [
    {
      title: "Total de tarefas",
      value: "3200",
      icon: <TaskIcon />,
      color: "#f44336",
      bgColor: "#ffebee",
    },
    {
      title: "Total de mensagens",
      value: "2200",
      icon: <EmailIcon />,
      color: "#9c27b0",
      bgColor: "#f3e5f5",
    },
    {
      title: "Total de lucro",
      value: "100,320",
      prefix: "R$ ",
      icon: <MoneyIcon />,
      color: "#00bcd4",
      bgColor: "#e0f2f1",
    },
    {
      title: "Total de documentos",
      value: "4567",
      icon: <DocumentIcon />,
      color: "#4caf50",
      bgColor: "#e8f5e8",
    },
  ];

  return (
    <Box>
      {/* Page Title */}
      <Typography
        variant="h4"
        sx={{
          mb: 3,
          fontWeight: 600,
          color: "#333",
        }}
      >
        Dashboard
      </Typography>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {statsCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                transition:
                  "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                },
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: "bold",
                        color: "#333",
                        mb: 0.5,
                        fontSize: "2.5rem",
                      }}
                    >
                      {card.prefix}
                      {card.value}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#666",
                        fontSize: "0.875rem",
                      }}
                    >
                      {card.title}
                    </Typography>
                  </Box>
                  <Avatar
                    sx={{
                      bgcolor: card.color,
                      width: 60,
                      height: 60,
                    }}
                  >
                    {card.icon}
                  </Avatar>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Content Placeholder */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card sx={{ p: 3, minHeight: 400 }}>
            <Typography variant="h6" sx={{ mb: 2, color: "#333" }}>
              Gráfico de ganhos
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 300,
                bgcolor: "#f8f9fa",
                borderRadius: 2,
                border: "2px dashed #dee2e6",
              }}
            >
              <Typography variant="h6" color="text.secondary">
                Gráfico será implementado aqui
              </Typography>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={{ p: 3, minHeight: 400 }}>
            <Typography variant="h6" sx={{ mb: 2, color: "#333" }}>
              Notificações
            </Typography>
            <Box sx={{ space: 2 }}>
              {[
                {
                  type: "error",
                  message: "Ops! Mude algumas coisas e tente enviar novamente.",
                  color: "#f44336",
                },
                {
                  type: "success",
                  message:
                    "Muito bem! Você leu com sucesso esta mensagem de alerta importante.",
                  color: "#4caf50",
                },
                {
                  type: "info",
                  message:
                    "Atenção! Este alerta precisa da sua atenção, mas não é super importante.",
                  color: "#2196f3",
                },
                {
                  type: "warning",
                  message:
                    "Atenção! É melhor você se verificar, você não está com boa aparência.",
                  color: "#ff9800",
                },
              ].map((notification, index) => (
                <Box
                  key={index}
                  sx={{
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    bgcolor: `${notification.color}15`,
                    border: `1px solid ${notification.color}30`,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: notification.color,
                      fontSize: "0.875rem",
                      lineHeight: 1.5,
                    }}
                  >
                    {notification.message}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
